// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

// mobx
import { observer } from 'mobx-react-lite'

// fragments
import { fragments } from 'services/get-fragments'

// react-router
import { Link } from 'react-router-dom'

// material-ui
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

export const HomePage = observer(() => {
  const header = fragments.Home?.header ?? ''
  const tagline = fragments.Home?.tagline ?? ''
  const gettingStarted = fragments.Home?.gettingStartedButton ?? 'Getting Started'
  const Fragment = fragments.Home?.jsx ?? (() => null)

  return (
    <>
      <Box sx={{ color: 'whitesmoke', backgroundColor: 'slategray', py: 5, textAlign: 'center', m: 0 }}>
        <Box component='img' src='/custom-content/home-image.png' sx={{ width: 150, mx: 'auto', marginBottom: '15px', display: 'block' }} alt='home' />
        <Typography variant='h4' component='h1' sx={{ color: 'whitesmoke' }}>{header}</Typography>
        <Typography>{tagline}</Typography>
        <Box sx={{ mt: 2 }}>
          <Link to='/getting-started' data-testid='gettingStartedLink' style={{ textDecoration: 'none' }}>
            <Button variant='contained' disableElevation color='success'>{gettingStarted}</Button>
          </Link>
        </Box>
      </Box>

      <Box sx={{ py: 5, mx: 'auto', fontSize: '2rem' }}>
        <Container maxWidth={false} sx={{ textAlign: 'justify', '& *': { fontSize: 'revert'} }}>
          <Fragment />
        </Container>
      </Box>
    </>
  )
})

export default HomePage
